module.exports = __webpack_public_path__ + "static/photo-s-mishra-85b710ab59399c6651495b85852647a4.jpeg";